import { render } from "./ResponsibleDataTable.vue?vue&type=template&id=4753e9ed&scoped=true"
import script from "./ResponsibleDataTable.vue?vue&type=script&lang=js"
export * from "./ResponsibleDataTable.vue?vue&type=script&lang=js"

import "./ResponsibleDataTable.vue?vue&type=style&index=0&id=4753e9ed&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4753e9ed"]])

export default __exports__